import React, {useState} from "react";

const ImageComponent = ({src}) => {
    const [imageExists, setImageExists] = useState(true);

    const handleImageError = () => {
        setImageExists(false);
    };

    return (
        <>
            {imageExists && (
                <img
                    src={src}
                    alt="Image"
                    onError={handleImageError}
                />
            )}
        </>
    );
};

export default ImageComponent;
